import type { AutologinFormData } from '@ts-student-app/interfaces'

import { useKidStore } from '@stores/kid'
import { useCustomerStore } from '@stores/me/customer'
import { useOptionsStore } from '@stores/options'

export const getStudentAppAutologin = (redirect: string | null = null): AutologinFormData | null => {
  const optionsStore = useOptionsStore()
  const kidStore = useKidStore()
  const customerStore = useCustomerStore()

  if (!customerStore.isPracticeEnabled) return null

  const raw = optionsStore.getStudentAppUrl
  const kidId = kidStore.activeKidId
  if (!raw || typeof kidId !== 'number') return null

  try {
    const url = new URL(raw)
    const signature = url.searchParams.get('signature')
    if (!signature) return null

    const landing = `${url.origin}${url.pathname}`

    return {
      action: redirect ? `${landing}?redirect=${encodeURIComponent(redirect)}` : landing,
      signature,
      kid: kidId,
    }
  } catch {
    return null
  }
}

export const canOpenStudentApp = (): boolean => !!getStudentAppAutologin()
